import { Pill } from '@/components/UI/Pill'

export type FilterTab = 'すべて' | '未達成' | '達成' | '完了' | '終了'

// TODO(#2319): FilterTab の内部識別子を日本語文字列から 'all' | 'achieved' | ... などの安定したキーに変更して
//              i18n 対応時にフィルタロジックが壊れないようにする
const TABS: FilterTab[] = ['すべて', '未達成', '達成', '完了', '終了']

type Props = {
  active?: FilterTab
  onChange?: (tab: FilterTab) => void
  className?: string
}

export function RewardFilterTabs({ active = 'すべて', onChange, className }: Props) {
  return (
    <div
      className={`flex items-center gap-2 overflow-x-auto px-4 py-3 ${className ?? ''}`}
      role="group"
      aria-label="特典絞り込み"
    >
      {TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          aria-pressed={active === tab}
          className="shrink-0 cursor-pointer border-none bg-transparent p-0"
          onClick={() => onChange?.(tab)}
        >
          <Pill type={active === tab ? 'Active' : 'Inactive'} label={tab} />
        </button>
      ))}
    </div>
  )
}
